import React, { useEffect, useState, useRef } from "react";
import Footer from "../Footer";
import Header from "../Header";
import Gallery from "../Gallery";
import UploadProgressGrid from "../Gallery/UploadProgressGrid";
import styled from "styled-components";
import { Container, Description } from "../Bootstrap";
import { vehicleSides, bikeSides } from "../../data/vehicle";
import ImageProcessor from "../ImageProcessor";
import { mobileScreen } from "../../assets/screens";
import {
  captureMode as mode,
  captureDesc,
  baseURL,
  balloonURL,
  dbCollection,
  pages,
} from "../../data/configs";
import axios from "../../lib/axios";
import NotyStack from "../Bootstrap/NotyStack";
import getLocation from "../../helpers/getLocation";
import { useStorageContext } from "../../core/storage-provider";
import { uploadBatchInBackground } from "../../utils/uploadPool";
import Claims from "../Sections/claims";
import UploadSubmissionProgress, {
  UPLOAD_STATUS,
} from "../Modals/UploadSubmissionProgress";
import {
  isReadyToSubmit,
  getIncompleteUploadMessage,
} from "../../utils/submissionHelpers";

const garageState = {
  captureIndex: 0,
  captureCount: 0,
  captures: new Map(),
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (parent) {
  const imageStore = useStorageContext();
  const {
    currentIndex,
    setCurrentIndex,
    setWarning,
    warning,
    setError,
    error,
    setSubmitted,
    setOpenModal,
    isInvalidToken,
    isClaims,
    page,
    setPage,
    pageCount,
    setPageCount,
  } = parent.operators;

  const hasToken = window.location.href.split("?token=")[1]?.length || null;

  const webcamRef = useRef(null);
  const [state, setState] = useState(garageState);
  const [userId] = useState(80);
  const [isLoading, setLoading] = useState(false);
  const [submissionProgress, setSubmissionProgress] = useState(null);
  const [imgData, setImgData] = useState("");
  const [captures, setCaptures] = useState(imageStore.__capturesAsArray());
  const [mappedCaptures, setMappedCaptures] = useState([]);
  const [aliasView, setAliasView] = useState("");
  const [percent, setPercent] = useState(0);
  const [captureMode] = useState(mode.camera);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploadCompleted, setUploadCompleted] = useState(false);
  const [clear, setClear] = useState(false);
  const [currentView, setCurrentView] = useState("");
  const [userLocation, setUserLocation] = useState("");
  const [camera, setCamera] = useState(false);
  const [isRequest, setIsRequest] = useState(false);
  const [capIndex, setCapIndex] = useState(0);
  const inputElement = useRef(null);
  const isSubmittingRef = useRef(false);
  const [captureSides, setCaptureSides] = useState(vehicleSides);

  if (!hasToken) {
    setError("Invalid url");
  }

  const captureSize = captures.length;
  const percentage = Math.round(
    (captureSize / (captureSides?.length || 1)) * 100
  );

  const hasCompletedCapture = captureSize === captureSides?.length;

  const vehicleReg = new URLSearchParams(
    window.location.href.split("?")[1]
  ).get("vehicle-reg");

  const vehicleType = new URLSearchParams(
    window.location.href.split("?")[1]
  ).get("vehicle-type");

  const openCamera = () => {
    inputElement.current.click();
  };

  const buildUploadEntries = () => {
    const captureMap =
      state.captures instanceof Map ? state.captures : new Map();
    return captureSides
      .filter((side) => captureMap.has(side.view))
      .map((side) => {
        const capture = captureMap.get(side.view);
        return { alias: side.alias, view: side.view, url: capture.url };
      });
  };

  const submitToApi = async (uploadedCaptures) => {
    setSubmissionProgress((prev) => ({
      ...prev,
      apiStatus: UPLOAD_STATUS.uploading,
    }));

    const authentic = localStorage.getItem("authentic");

    if (!hasToken || !+authentic) {
      throw new Error("Not authenticated");
    }

    const token = new URLSearchParams(window.location.href.split("?")[1]).get(
      "token"
    );
    const isBalloon =
      new URLSearchParams(window.location.href.split("?")[1]).get(
        "platform"
      ) === "balloon";
    const baseUrl = `${
      isBalloon ? balloonURL : baseURL
    }/${dbCollection}/captures/${token}`;

    const payload = {
      ...userLocation,
      ...uploadedCaptures,
    };
    const request = axios("key-api");
    await request.post(baseUrl, payload);

    setSubmissionProgress((prev) => ({
      ...prev,
      apiStatus: UPLOAD_STATUS.done,
    }));

    setOpenModal(true);
    setSubmitted(true);
    clearCaptures();
  };

  const uploadItems = async (items, existingResults = {}) => {
    const results = { ...existingResults };
    const updatedItems = items.map((item) => ({ ...item }));

    const jobs = updatedItems
      .map((item, index) => ({ item, index }))
      .filter(({ item }) => {
        if (item.status === UPLOAD_STATUS.done && results[item.alias]) {
          return false;
        }
        return (
          item.status === UPLOAD_STATUS.pending ||
          item.status === UPLOAD_STATUS.error
        );
      })
      .map(({ item, index }) => ({
        index,
        alias: item.alias,
        file: item.url,
      }));

    if (jobs.length === 0) {
      return { results, items: updatedItems };
    }

    await uploadBatchInBackground(jobs, {
      onItemUploading: (index) => {
        setSubmissionProgress((prev) =>
          prev
            ? {
                ...prev,
                items: prev.items.map((entry, idx) =>
                  idx === index
                    ? { ...entry, status: UPLOAD_STATUS.uploading }
                    : entry
                ),
              }
            : prev
        );
      },
      onItemSuccess: (index, alias, data) => {
        const uploaded = {
          url: data.secure_url,
          publicId: data.public_id,
        };
        results[alias] = uploaded;
        updatedItems[index] = {
          ...updatedItems[index],
          status: UPLOAD_STATUS.done,
        };
        setSubmissionProgress((prev) =>
          prev
            ? {
                ...prev,
                results: { ...prev.results, [alias]: uploaded },
                items: prev.items.map((entry, idx) =>
                  idx === index
                    ? { ...entry, status: UPLOAD_STATUS.done }
                    : entry
                ),
              }
            : prev
        );
      },
      onItemError: (index, alias, err) => {
        updatedItems[index] = {
          ...updatedItems[index],
          status: UPLOAD_STATUS.error,
        };
        setSubmissionProgress((prev) =>
          prev
            ? {
                ...prev,
                items: prev.items.map((entry, idx) =>
                  idx === index
                    ? { ...entry, status: UPLOAD_STATUS.error }
                    : entry
                ),
              }
            : prev
        );
        console.error(`Upload failed for ${alias}:`, err);
      },
    });

    return { results, items: updatedItems };
  };

  const runSubmission = async () => {
    if (isSubmittingRef.current) return;
    isSubmittingRef.current = true;
    setIsRequest(true);
    setWarning(null);
    setError(null);

    try {
      const entries = buildUploadEntries();
      if (entries.length === 0) return;

      const initialProgress = {
        items: entries.map((e) => ({ ...e, status: UPLOAD_STATUS.pending })),
        apiStatus: UPLOAD_STATUS.pending,
        results: {},
      };
      setSubmissionProgress(initialProgress);

      const { results, items } = await uploadItems(
        initialProgress.items,
        initialProgress.results
      );

      setSubmissionProgress((prev) =>
        prev ? { ...prev, items, results } : prev
      );

      if (!isReadyToSubmit(items, results)) {
        setWarning(getIncompleteUploadMessage(items, results));
        return;
      }

      await submitToApi(results);
    } catch (error) {
      setSubmissionProgress((prev) =>
        prev ? { ...prev, apiStatus: UPLOAD_STATUS.error } : prev
      );
      if (error.response?.data?.message && !isInvalidToken) {
        setError(error.response.data.message);
      } else if (error.message !== "Not authenticated") {
        setError("Failed to submit captures. Please try again.");
      }
      console.error(error);
    } finally {
      isSubmittingRef.current = false;
      setIsRequest(false);
    }
  };

  const saveCaptures = () => runSubmission();

  const retryFailedUploads = async () => {
    if (isSubmittingRef.current || !submissionProgress) return;

    isSubmittingRef.current = true;
    setIsRequest(true);
    setWarning(null);

    try {
      const { results, items } = await uploadItems(
        submissionProgress.items,
        submissionProgress.results || {}
      );

      setSubmissionProgress((prev) =>
        prev ? { ...prev, items, results, apiStatus: UPLOAD_STATUS.pending } : prev
      );

      if (!isReadyToSubmit(items, results)) {
        setWarning(getIncompleteUploadMessage(items, results));
        return;
      }

      await submitToApi(results);
    } catch (error) {
      setSubmissionProgress((prev) =>
        prev ? { ...prev, apiStatus: UPLOAD_STATUS.error } : prev
      );
      if (error.response?.data?.message && !isInvalidToken) {
        setError(error.response.data.message);
      } else {
        setError("Failed to submit captures. Please try again.");
      }
      console.error(error);
    } finally {
      isSubmittingRef.current = false;
      setIsRequest(false);
    }
  };

  const retryApiSubmit = async () => {
    if (isSubmittingRef.current || !submissionProgress?.results) return;

    isSubmittingRef.current = true;
    setIsRequest(true);
    setError(null);

    try {
      await submitToApi(submissionProgress.results);
    } catch (error) {
      setSubmissionProgress((prev) =>
        prev ? { ...prev, apiStatus: UPLOAD_STATUS.error } : prev
      );
      if (error.response?.data?.message && !isInvalidToken) {
        setError(error.response.data.message);
      } else {
        setError("Failed to submit captures. Please try again.");
      }
      console.error(error);
    } finally {
      isSubmittingRef.current = false;
      setIsRequest(false);
    }
  };

  const dismissSubmissionProgress = () => {
    setSubmissionProgress(null);
    setIsRequest(false);
  };

  const clearCaptures = () => {
    setCaptures([]);
    setClear(true);
  };

  useEffect(() => {
    let isMounted = true;

    const setLocation = async () => {
      const location = await getLocation();
      if (!isMounted) return;
      setUserLocation(location);
    };

    setLocation();

    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    if (typeof window !== "undefined" && vehicleType === "motorcycle") {
      setCaptureSides(bikeSides);
    } else {
      setCaptureSides(vehicleSides);
    }
  }, [vehicleType]);

  useEffect(() => {
    const currentSide = captureSides[currentIndex];
    if (!currentSide) return;
    const justUploaded = captures.some((c) => c.view === currentSide.view);
    if (!justUploaded) return;

    const nextPending = captureSides.findIndex(
      (side) => !captures.some((c) => c.view === side.view)
    );
    if (nextPending !== -1 && nextPending !== currentIndex) {
      setCurrentIndex(nextPending);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [captures.length]);

  useEffect(() => {
    if (percent > captureSides?.length) return;
    setCurrentView(captureSides?.[currentIndex]?.view);
    setPercent(captureSize);
    const __captures = new Map(
      captures.map((capture) => {
        const side =
          captureSides.find((s) => s.view === capture.view) ||
          captureSides[currentIndex];
        const { view, alias } = side;
        return [view, { url: capture.url, view, alias }];
      })
    );
    setState({
      clear,
      setClear,
      captureCount: captureSize,
      uploadProgress,
      uploadCompleted,
      setUploadProgress,
      clearCaptures,
      setUploadCompleted,
      setCurrentView,
      captureMode,
      setImgData,
      webcamRef,
      openCamera,
      camera,
      isInvalidToken,
      setCamera,
      setWarning,
      captures: __captures,
    });

    imageStore.__setImage(__captures);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uploadCompleted, currentIndex, captures, captureSides, captureSize]);

  let headerSubtext = {
    vehicleInfo: "Select the vehicle you are making a claim on.",
    driverInfo:
      "We would like to ask some information about the vehicle involved",
    incidentInfo: "We would like to ask some information about the incident",
  };

  let headerText = {
    vehicleInfo: "Driving Question",
    driverInfo: "Driving Question",
    incidentInfo: "Driving Question",
    vehicleCapture:
      vehicleType !== "motorcycle" ? "Vehicle Capture" : "Bike Capture",
  };

  headerSubtext = headerSubtext[page];
  headerText = headerText[page];

  return (
    <Container fluid={true} className="p-0">
      <UploadSubmissionProgress
        progress={submissionProgress}
        onDismiss={dismissSubmissionProgress}
        onRetryFailed={retryFailedUploads}
        onRetrySubmit={retryApiSubmit}
        isRetrying={isRequest}
      />
      {error && <NotyStack message={error} variant="error" />}
      {warning && <NotyStack message={warning} variant="warning" />}

      <Header
        percent={percentage}
        isClaims={pages.vehicleCapture !== page}
        headerSubtext={headerSubtext}
        headerText={headerText}
      />

      {page === pages.vehicleCapture ? (
        <Container>
          <Description>
            
            {!isClaims && (
              <h3 className="text-center fs-2" style={{ fontWeight: "400" }}>
                {captureDesc[captureMode]} of your{" "}
                {vehicleType !== "motorcycle" ? "car" : "bike"}
              </h3>
            )}
            <h3
              className="text-center"
              style={{ fontWeight: "400", fontSize: "16px" }}
            >
              {vehicleType !== "motorcycle" ? "Vehicle" : "Bike"} plate -{" "}
              {vehicleReg}
            </h3>

            <SubTitle>
              {!isClaims
                ? "Use the image below as a guide, the red box shoud be the area of focus"
                : headerSubtext}
            </SubTitle>
          </Description>

          <ImageProcessor
            state={{
              captures,
              setUploadCompleted,
              setCaptures,
              userId,
              setUploadProgress,
              currentView,
              error,
              setError,
              setWarning,
              captureMode,
              hasToken,
              currentIndex,
              imgData,
              mappedCaptures,
              setMappedCaptures,
              aliasView,
              setAliasView,
              hasCompletedCapture,
              inputElement,
              isClaims,
              setLoading,
            }}
          />

          <Gallery
            capIndex={capIndex}
            setCapIndex={setCapIndex}
            imageInputs={state}
            setCurrentIndex={setCurrentIndex}
            currentIndex={currentIndex}
          />
          <UploadProgressGrid
            captureSides={captureSides}
            captures={state.captures}
            currentIndex={currentIndex}
            setCurrentIndex={setCurrentIndex}
            isLoading={isLoading}
          />
        </Container>
      ) : (
        <Claims page={page} />
      )}
      <Footer
        pageAction={{ page, setPage, pageCount, setPageCount }}
        disabled={!hasCompletedCapture || !!submissionProgress || isRequest}
        saveCaptures={saveCaptures}
        clearCaptures={clearCaptures}
        action={{ setIsRequest, isRequest }}
        currentIndex={currentIndex}
      />
    </Container>
  );
}

const SubTitle = styled("span")`
  font-size: 14px;
  ${mobileScreen(`
    font-size: 14px;
  `)}
`;
